import React, { Component } from "react"
import { getQueryStringValue, setQueryStringValue, getQueryStringKeys } from "../../api/queryStringHelper"
import * as cookieNames from "../../booking/constants/Cookies"
import * as cookieHelper from "../../helpers/cookie"
import * as TransportToAirport from "./TransportationToAirportTypes"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export class ItineraryTravelInformation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
    }

    this.showHideContent = this.props.showHideContent.bind(this)
    this.setDataToState = this.props.setDataToState.bind(this)
  }

  componentDidMount() {
    let queryParamData = this.getTravelInformationFromQuery()
    if (this.objectIsNotEmpty(queryParamData)) {
      this.setDataToState({ travelInformationData: queryParamData }, true)
    } else if (this.objectIsNotEmpty(this.props.travelInformationData)) {
      // set query parameters from cookie data
      for (const key in this.props.travelInformationData) {
        setQueryStringValue(key, this.props.travelInformationData[key])
      }
    }
  }

  setTravelInformationCookie = (data) => {
    let cookieData = data
    cookieData.expire = this.props.flightInfo.EstimatedPublicTime
    cookieHelper.setCookieWithExpiration(cookieNames.CPH_TRAVEL_INFORMATION, cookieData, this.props.flightInfo.EstimatedPublicTime) //cookie will be set server side the next time the page loads
  }

  getTravelInformationFromQuery = () => {
    let travelInformationData = {}
    const qsKeys = getQueryStringKeys()
    const travelForm = getQueryStringValue("tf") || undefined
    const travelWithKids =
      getQueryStringValue("twc") === "true"
        ? true
        : getQueryStringValue("twc") === "false"
          ? false
          : getQueryStringValue("twc") === "null"
            ? null
            : undefined
    const travelWithLuggage =
      getQueryStringValue("twl") === "true"
        ? true
        : getQueryStringValue("twl") === "false"
          ? false
          : getQueryStringValue("twl") === "null"
            ? null
            : undefined
    if (qsKeys.includes("tf")) travelInformationData["tf"] = travelForm
    if (qsKeys.includes("twc")) travelInformationData["twc"] = travelWithKids
    if (qsKeys.includes("twl")) travelInformationData["twl"] = travelWithLuggage

    return travelInformationData
  }

  nextStep(event, update = false) {
    let elem = event.currentTarget
    let parent = elem.closest(".departure-info__essentials__adjust-travel-info__step")
    parent.classList.remove("active")
    parent.nextSibling.classList.add("active")
    const dataName = elem.dataset.name
    const dataValue = elem.dataset.value
    if (update) {
      this.updateTravelInformation(dataName, dataValue)
    }
  }

  prevStep(event) {
    let elem = event.currentTarget
    let parent = elem.closest(".departure-info__essentials__adjust-travel-info__step")
    parent.classList.remove("active")
    parent.previousSibling.classList.add("active")
    parent.previousSibling.querySelector(".next-arrow").style.display = "block"
  }

  objectIsNotEmpty = (obj) => {
    return obj !== null && obj !== undefined && obj !== {} && Object.keys(obj).length > 0
  }

  updateTravelInformation = (name, data) => {
    let dataValue = data
    dataValue = dataValue === "true" ? true : dataValue === "false" ? false : dataValue || null
    let travelInformationData = this.props.travelInformationData || {}
    travelInformationData[name] = dataValue
    setQueryStringValue(name, dataValue)
    this.setDataToState({ travelInformationData: travelInformationData }, true)
    this.setTravelInformationCookie(travelInformationData)
  }

  render() {
    let tpStep1ProgressWidth = { width: "33.33%" }
    let tpStep2ProgressWidth = { width: "66.67%" }
    let tpStep3ProgressWidth = { width: "100%" }

    const luggageAnswers = [
      { name: "twl", value: true, answerText: this.props.block.answerYesLuggage || "Ja, jeg skal checke bagage ind" },
      { name: "twl", value: false, answerText: this.props.block.answerNoLuggage || "Nej, jeg har kun håndbagage" },
      { name: "twl", value: null, answerText: this.props.block.answerDoNotKnowLuggage || "Det ved jeg ikke endnu" },
    ]
    const childrenAnswers = [
      { name: "twc", value: true, answerText: this.props.block.answerYesChildren || "Ja" },
      { name: "twc", value: false, answerText: this.props.block.answerNoChildren || "Nej" },
    ]
    const transportAnswers = [
      {
        name: "tf",
        value: TransportToAirport.PARKING,
        answerText: this.props.block.answerParkingTransport || "Jeg parkerer i lufthavnen (Fra 399 kr.)",
      },
      { name: "tf", value: TransportToAirport.DRIVEN_BY_ANOTHER, answerText: this.props.block.answerDrivenTransport || "Jeg bliver sat af" },
      {
        name: "tf",
        value: TransportToAirport.PUBLIC_TRANSPORTATION,
        answerText: this.props.block.answerPublicTransport || "Jeg kommer med Metro/Tog/Bus",
      },
      { name: "tf", value: null, answerText: this.props.block.answerOtherTransport || "Det ved jeg ikke endnu" },
    ]

    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    return (
      <div className="departure-info__essentials__adjust-travel-info">
        <div className="departure-info__essentials__adjust-travel-info__box foldable">
          <div
            className="departure-info__essentials__adjust-travel-info__box__first-step pointer"
            onClick={(e) => this.showHideContent(e, ".contentWrapper", false)}
          >
            <div className="departure-info__essentials__adjust-travel-info__desc">
              {this.props.block.text || "Kender vi mere til din rejse kan vi tilpasse informationen og forberede dig bedre."}
            </div>
            <div className="departure-info__essentials__adjust-travel-info__toggle">
              {this.props.block.accordionButtonText || "Tilpas din rejse her."}
            </div>
          </div>
          <div className="contentWrapper show-hide">
            <div className="departure-info__essentials__adjust-travel-info__step__header">
              {this.props.block.headline || "Tilpas rejseinformation"}
            </div>
            <TravelInformationStep
              active={this.objectIsNotEmpty(this.props.travelInformationData) ? false : true}
              question={this.props.block.questionLuggage || "Checker du bagage ind?"}
              answers={luggageAnswers}
              questionLabel={this.props.block.questionLabel || "Spørgsmål"}
              stepNumber={1}
              stepAmount={3}
              progressStyle={tpStep1ProgressWidth}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              updateTravelInformation={this.updateTravelInformation}
              buttonColor={buttonColor}
            />
            <TravelInformationStep
              active={false}
              question={this.props.block.questionChildren || "Rejser du med små børn?"}
              answers={childrenAnswers}
              questionLabel={this.props.block.questionLabel || "Spørgsmål"}
              stepNumber={2}
              stepAmount={3}
              progressStyle={tpStep2ProgressWidth}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              updateTravelInformation={this.updateTravelInformation}
              buttonColor={buttonColor}
            />
            <TravelInformationStep
              active={false}
              question={this.props.block.questionTransport || "Hvordan planlægger du at ankomme til lufthavnen?"}
              answers={transportAnswers}
              questionLabel={this.props.block.questionLabel || "Spørgsmål"}
              stepNumber={3}
              stepAmount={3}
              progressStyle={tpStep3ProgressWidth}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              updateTravelInformation={this.updateTravelInformation}
              buttonColor={buttonColor}
            />
            <div
              className={`departure-info__essentials__adjust-travel-info__step ${
                this.objectIsNotEmpty(this.props.travelInformationData) ? "active" : ""
              }`}
            >
              <div className="departure-info__essentials__adjust-travel-info__step__counter">{this.props.block.resultLabel || "Resultat"}</div>
              <div className="departure-info__essentials__adjust-travel-info__step__progressbar">
                <div className="departure-info__essentials__adjust-travel-info__step__progressbar__inner" style={tpStep3ProgressWidth}></div>
              </div>
              <div className="departure-info__essentials__adjust-travel-info__step__question">
                <img className="prev-arrow" src="/static/arrowleft-blue.svg" onClick={(e) => this.prevStep(e)} alt="" />
                {this.props.block.thankYouHeadline || "Tak for dine inputs"}
              </div>
              <div className="departure-info__essentials__adjust-travel-info__step__result">
                <div className="departure-info__essentials__adjust-travel-info__step__result__img">
                  {this.props.block.thankYouIcon ? (
                    <img src={this.props.block.thankYouIcon} alt="" />
                  ) : (
                    <img src="/static/thumbsup-blue.svg" alt="" />
                  )}
                </div>
                <div className="departure-info__essentials__adjust-travel-info__step__result__desc">
                  {this.props.block.thankYouText || "Vi tilpasset din rejseplan ud fra disse kriterier"}
                </div>
                <div className="departure-info__essentials__adjust-travel-info__step__result__topics grid">
                  <div className="departure-info__essentials__adjust-travel-info__step__result__topic grid-item col--4">
                    {this.props.block.luggageLabel || "Baggage"}
                  </div>
                  <div className="departure-info__essentials__adjust-travel-info__step__result__topic grid-item col--4">
                    {this.props.block.childrenLabel || "Børn"}
                  </div>
                  <div className="departure-info__essentials__adjust-travel-info__step__result__topic grid-item col--4">
                    {this.props.block.transportLabel || "Parkering"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="departure-info__essentials__adjust-travel-info__close pointer"
            onClick={(e) => this.showHideContent(e, ".contentWrapper", false)}
          ></div>
        </div>
      </div>
    )
  }
}

class TravelInformationStep extends Component {
  constructor(props) {
    super(props)

    this.updateTravelInformation = this.props.updateTravelInformation.bind(this)
  }
  render() {
    return (
      <div className={`departure-info__essentials__adjust-travel-info__step ${this.props.active ? "active" : ""}`}>
        <div className="departure-info__essentials__adjust-travel-info__step__counter">{`${this.props.questionLabel} ${this.props.stepNumber}/${this.props.stepAmount}`}</div>
        <div className="departure-info__essentials__adjust-travel-info__step__progressbar">
          <div className="departure-info__essentials__adjust-travel-info__step__progressbar__inner" style={this.props.progressStyle}></div>
        </div>
        <div className="departure-info__essentials__adjust-travel-info__step__question">
          {this.props.stepNumber > 1 ? (
            <img className="prev-arrow" src="/static/arrowleft-blue.svg" onClick={(e) => this.props.prevStep(e)} alt="" />
          ) : (
            ""
          )}
          {this.props.question}
          <img className="next-arrow" src="/static/arrowright-blue.svg" onClick={(e) => this.props.nextStep(e)} alt="" />
        </div>
        <div className="departure-info__essentials__adjust-travel-info__step__answers">
          {this.props.answers && this.props.answers.length > 0
            ? this.props.answers.map((answer, index) => {
                return (
                  <button
                    key={index}
                    className={`button button--small button--discreet ${this.props.buttonColor ? this.props.buttonColor : ""}`}
                    data-name={answer.name}
                    data-value={answer.value}
                    onClick={(e) => this.props.nextStep(e, true)}
                  >
                    {answer.answerText}
                  </button>
                )
              })
            : ""}
        </div>
      </div>
    )
  }
}
